"use client";
import { getBackgroundColor } from "../../../utils/color.js";
import { styled } from "@mui/material/styles";
import { ColorGray300, SpaceXs, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
import GenericImageHandler from "../../Util/GenericImageHandler.js";
const StyledProgramCard = styled(CostcoBox)`
    border: 1px solid ${ColorGray300};
    border-radius: 10px;
`;
const StyledBottomStrip = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "bottomStrip"
})(({ bottomStrip }) => {
  var _a;
  return {
    background: getBackgroundColor((_a = bottomStrip == null ? void 0 : bottomStrip.bottom_strip_text) == null ? void 0 : _a.color),
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    display: "flex",
    justifyContent: bottomStrip == null ? void 0 : bottomStrip.alignment,
    padding: `${SpaceXs} ${SpaceLg}`
  };
});
const FillImage = styled(GenericImageHandler)({
  height: "auto",
  width: "100%"
});
export {
  FillImage,
  StyledBottomStrip,
  StyledProgramCard
};
